// Docs are ordered lists of sections built from the reusable blocks in ./blocks.
// A section is one of:
//   'block.id'                                   a block shown inline
//   { accordion: true, title, doc: 'doc.id' }    collapsible, shows the sections of another doc
//   { accordion: true, title, sections: [...] }  collapsible, shows its own list of sections
export default {
  'events.settings': {
    title: 'Event type and its settings',
    sections: [
      'events.types',
      'events.rounds',
      'events.judges',
      'events.noHorse'
    ]
  },
  'events.split': {
    title: 'How splitting events works',
    sections: [
      'split.intro',
      'split.availability',
      'split.regular',
      'split.combined',
      'split.conjunction',
      'split.after'
    ]
  },
  'secretaries.super': {
    title: 'Super Secretary',
    sections: [
      'secretaries.super.what',
      'secretaries.super.why',
      'secretaries.super.how'
    ]
  },
  'events.guide': {
    title: 'How events work',
    sections: [
      'events.what',
      'events.kinds.intro',
      'events.kind.regular',
      'events.kind.combined',
      'events.kind.conjunction',
      { accordion: true, title: 'Event type and its settings', doc: 'events.settings' },
      { accordion: true, title: 'How splitting events works', doc: 'events.split' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/docs/docs.js